import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';
import LockIcon from '@mui/icons-material/Lock';

const Unauthorized = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <LockIcon sx={{ fontSize: 64, color: '#1B5E20', mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#1B5E20' }}>
          Access Denied
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          You don't have permission to access this page. If you believe this is an error,
          please contact your administrator.
        </Typography>
        <Button
          component={Link}
          to="/dashboard"
          variant="contained"
          sx={{
            backgroundColor: '#96ffa8',
            color: '#1B5E20',
            '&:hover': {
              backgroundColor: '#82e694',
            },
          }}
        >
          Return to Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default Unauthorized; 